export default __webpack_public_path__ + "static/favicon-e5b4623725c250b3b53f214a522558c8.ico";